<template>
  <section
    v-if="product"
    :key="product ? product.id : 'empty'"
    class="product half-splitted-bg"
  >
    <PageTitle
      :title="$currentCollection.claim"
      class="product-title"
    />
    <PushButton
      v-if="!$isMobile"
      :label="$config.common.faq.cta"
      :background="`collections-${$store.state.theme}-pattern-push`"
      class="product-faq-cta"
      @click.native="scrollToFaq"
    />
    <main class="product-details">
      <ViewerWrapper
        :product="product"
        class="product-viewer"
      >
        <template v-slot:before>
          <div class="product-details__info">
            <h2
              class="product-details__title"
              v-html="product.label"
            />
            <CollectionPanel :product="product" />
          </div>
        </template>
        <template v-slot:default>
          <ProductCard :product="product" />
        </template>
      </ViewerWrapper>
      <ScrollIcon class="scroll-icon" />
    </main>
    <RelatedProductsNavigation
      :product="product"
      class="related-products-navigation"
    />
    <FaqSection
      class="product-faq-panel"
    />
  </section>
  <div v-else>
    not found
  </div>
</template>

<script>
import ProductCard from '@/components/layouts/products/ProductCard.vue';
import CollectionPanel from '@/components/layouts/products/CollectionPanel.vue';
import PageTitle from '@/components/common/PageTitle.vue';
import ViewerWrapper from '@/components/viewer/ViewerWrapper.vue';
import RelatedProductsNavigation from '@/components/layouts/products/RelatedProductsNavigation.vue';
import FaqSection from '@/components/common/FaqSection.vue';
import PushButton from '@/components/common/PushButton.vue';
import ScrollIcon from '@/assets/images/common/icons/scroll.svg?inline';

export default {
  name: 'Products',

  components: {
    ProductCard,
    CollectionPanel,
    PageTitle,
    ViewerWrapper,
    ScrollIcon,
    FaqSection,
    RelatedProductsNavigation,
    PushButton,
  },

  data() {
    return {

    };
  },
  computed: {
    product() {
      return this.$store.getters.getProductById(`${this.$route.params.collectionId}-${this.$route.params.id}`);
    },
  },
  mounted() {
    if (!this.$route.params.id) {
      this.router.replace({
        name: 'products',
        params: {
          collectionId: this.$route.params.collectionId,
          id: this.collection.products[0].id,
        },
      });
    }
  },

  methods: {
    scrollToFaq() {
      const faqElement = document.getElementById('faq');
      if (faqElement) {
        faqElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
      }
    },
  },
};
</script>

<style lang="stylus" scoped>

.product {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 89px);
  justify-content: center;
  padding: 40px 0 0;
  +mobile(){
    padding: 40px 0 30px;
  }

  .product-title {
  }

  .product-faq-cta {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 240px;
  }

  .product-details {
    position: relative
    margin: 0;
    padding: 60px 0;
    border-bottom: 1px solid var(--white-color);
    +mobile() {
      margin: 0 20px;
      padding: 0;
    }
    h2 {
      font-weight: 700;
      text-transform: uppercase;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      font-size: 28px;
      margin-bottom: 15px;
      text-align: left;
      +mobile() {
        margin-top: 10px;
        color: var(--inverted-text-color);
      }
    }

    .product-details__info {
      width: 250px;
      +mobile() {
        width: 100%;
      }
    }

    .scroll-icon {
      position: absolute;
      bottom: 10px;
      right: 20px;
      transform: translateX(0);
      animation: bounce 2s infinite;
      * {
        stroke: var(--main-color);
      }

      +mobile() {
        display: none;
      }

      @keyframes bounce {
        0%, 100% {
          transform: translateY(0);
        }
        50% {
          transform: translateY(-10px);
        }
      }
    }
  }

}
</style>
